import ROUTE_NAMES from "@/app/exercise/router/router-const";
export default [
  {
    path: "trainings",
    name: ROUTE_NAMES.TRAININGS,
    component: () =>
      import("@/app/exercise/modules/trainings/TrainingsPage.vue")
  }
];
